import React, { useEffect, useRef, FC, useState } from 'react'
import { Button, message, notification } from 'antd'
import { YHModal } from '@/components/YHModal'
import { YhFormBox } from '@/components/YhFormBox'
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, IYhFormRef } from '@/components/YhFormBox/Types'
import { ISupplierSupplyDetails } from '@/views/supplier/supplierTypes'
import { useSupplyDetailsMode } from './supplyDetailsModel'
import { supplierService } from '../../../supplierService'

export const SupplyDetailsModal: FC<{}> = () => {
    const { modalVisible: visible, modalMode: mode, currentRecord: data, handleClose, loadData } = useSupplyDetailsMode()
    const formRef = useRef<IYhFormRef>()
    const [formValues, setFormValues] = useState<ISupplierSupplyDetails | {}>({})
    const [saveLoading, setSaveLoading] = useState(false)

    // 当弹窗打开且有数据时，设置表单值
    useEffect(() => {
        if (visible && data) {
            setFormValues(data)
        } else {
            setFormValues({})
        }
    }, [visible, data])

    // 表单change事件
    const onChange = (changedValues: { [key: string]: any }, values: ISupplierSupplyDetails) => {
        setFormValues(values)
    }

    // 保存操作
    const handleSave = () => {
        if (mode === 'view') {
            handleClose()
            return
        }
        formRef.current
            ?.validateFields()
            .then(async (values) => {
                setSaveLoading(true)
                let param = { ...data, ...values }
                let { retData } = await supplierService.SupplyDetailsUpdate(param)
                if (retData) {
                    setSaveLoading(false)
                    message.success('保存成功！')
                    handleClose()
                }
                loadData()
            })
            .catch(() => {
                setSaveLoading(false)
                loadData()
            })
    }

    // 表单配置
    const baseFormItem: IYhFormItemsBox = {
        // title: mode === 'view' ? '供应详情信息' : '编辑供应详情',
        style: { padding: '10px 0 0 0', marginBottom: '15px' },
        contentClass: 'pr-77',
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '商品编号',
                fieldName: 'materialCode',
                disable: true,
                rules: mode === 'edit' ? [{ required: true, message: '请输入商品编号' }] : [],
                span: 12,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '商品名称',
                fieldName: 'materialName',
                disable: true,
                rules: mode === 'edit' ? [{ required: true, message: '请输入商品名称' }] : [],
                span: 12,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '单位',
                fieldName: 'unit',
                disable: mode === 'view',
                span: 12,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '型号',
                fieldName: 'model',
                disable: mode === 'view',
                span: 12,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '品系',
                fieldName: 'productLine',
                disable: mode === 'view',
                span: 12,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '品种',
                fieldName: 'variety',
                disable: mode === 'view',
                span: 12,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '生产厂家',
                fieldName: 'manufacturer',
                disable: mode === 'view',
                span: 12,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '品牌',
                fieldName: 'brand',
                disable: mode === 'view',
                span: 12,
                rules: mode === 'edit' ? [{ required: true, message: '请输入商品名称' }] : [],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '配件返利类别',
                fieldName: 'rebateCategory',
                disable: mode === 'view',
                span: 12,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '供货价格',
                fieldName: 'supplyPrice',
                disable: mode === 'view',
                rules:
                    mode === 'edit'
                        ? [
                              { required: true, message: '请输入供货价格' },
                              {
                                  pattern: /^\d+(\.\d{1,2})?$/,
                                  message: '请输入有效的数字，最多保留2位小数',
                              },
                          ]
                        : [],
                precision: 2,
                min: 0,
                span: 12,
            },
        ],
    }

    const formConfig: IYhFormBox<ISupplierSupplyDetails> = {
        formRef,
        labelCol: { span: 6 },
        labelAlign: 'right',
        formValues: formValues as ISupplierSupplyDetails,
        onChange,
        boxs: [baseFormItem],
    }

    return (
        <YHModal
            visible={visible}
            title={mode === 'view' ? '查看货明细' : '编辑货明细'}
            width={800}
            bodyHeight={400}
            showFooter={true}
            onCancel={handleClose}
            cancelText="关闭"
            okText={mode === 'view' ? '关闭' : '保存'}
            onOk={handleSave}
        >
            <div style={{ padding: '20px' }}>
                <YhFormBox {...formConfig} />
            </div>
        </YHModal>
    )
}
